import { MAX_PERFORMER_EVENTS_REQUESTS_SIZE } from 'meta/pages/v4/performer'
import { joinParts } from '../utils'

export const performer = {
  data: (code: string) => joinParts('performers', code),
  bulk: (codes: string[]) => `/performers?ids=${codes.join(',')}`,
  activeEvents: (code: string, page: number) =>
    `performers/${code}/events?page=${page}&size=${MAX_PERFORMER_EVENTS_REQUESTS_SIZE}`,
  activeTypeticketcollections: (code: string, page: number) =>
    `performers/${code}/typeTicketCollections?page=${page}&size=${MAX_PERFORMER_EVENTS_REQUESTS_SIZE}`,
  metadata: (code: string) => joinParts('meta', 'performer', code),
}
